import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadMapaConcretagemArquivoUseCase } from "../../../presentation/useCases/read/download_mapa_concretagem_arquivo_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DownloadMapaConcretagemArquivoUseCase
 */

export class DownloadMapaConcretagemArquivoUseCase implements IDownloadMapaConcretagemArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async downloadMapaConcretagemArquivo(
    idMapaConcretagem: number,
    nomeArquivo: string,
    nroArquivo: number,
  ): Promise<void> {
    const results = await this.repository.downloadMapaConcretagemArquivo(
      idMapaConcretagem, nroArquivo);
    await downloadFromBlobUrl(results, nomeArquivo);
  }
}
